export default {
  setList(store, list) {
    store.commit('setList', list);
  },
};
